// This file is auto-generated by @hey-api/openapi-ts

import type { Client, Options as Options2, TDataShape } from './client';
import { client } from './client.gen';
import type {
  GetContentPageData,
  GetContentPageResponses,
  GetPromoReviewsData,
  GetPromoReviewsResponses,
  GetServiceStatisticsData,
  GetServiceStatisticsResponses,
  GetTravelersFaqData,
  GetTravelersFaqResponses,
} from './types.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = Options2<
  TData,
  ThrowOnError
> & {
  /**
   * You can provide a client instance returned by `createClient()` instead of
   * individual options. This might be also useful if you want to implement a
   * custom client.
   */
  client?: Client;
  /**
   * You can pass arbitrary values through the `meta` object. This can be
   * used to access values that aren't defined as part of the SDK function.
   */
  meta?: Record<string, unknown>;
};

/**
 * Get content page by slug
 */
export const getContentPage = <ThrowOnError extends boolean = false>(
  options: Options<GetContentPageData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetContentPageResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/content-pages/{slug}/',
    ...options,
  });

/**
 * Get service statistics
 */
export const getServiceStatistics = <ThrowOnError extends boolean = false>(
  options?: Options<GetServiceStatisticsData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetServiceStatisticsResponses, unknown, ThrowOnError>({
    url: '/api/statistic/',
    ...options,
  });

/**
 * Get traveler FAQ
 */
export const getTravelersFaq = <ThrowOnError extends boolean = false>(
  options?: Options<GetTravelersFaqData, ThrowOnError>,
) =>
  (options?.client ?? client).get<GetTravelersFaqResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/help_center/travelers/questions/',
    ...options,
  });

/**
 * Get promo reviews
 *
 * Promo reviews list
 */
export const getPromoReviews = <ThrowOnError extends boolean = false>(
  options: Options<GetPromoReviewsData, ThrowOnError>,
) =>
  (options.client ?? client).get<GetPromoReviewsResponses, unknown, ThrowOnError>({
    url: '/api/web/v1/reviews/',
    ...options,
  });
